import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { Dialog } from "primereact/dialog";
import { selectPositiveItemToEdit } from "../../store/selectors/positiveItemSelectors";
import { PositiveItemForm } from "./PositiveItemForm";
import { setToEdit } from "../../store/slices/positiveItemSlice";

export const PositiveItemDialog = () => {
    const dispatch = useAppDispatch();

    const toEdit = useAppSelector(selectPositiveItemToEdit);

    if (!toEdit) {
        return null;
    }

    const onHide = () => {
        dispatch(setToEdit(undefined));
    };

    const header = toEdit.id ? "Edit Positive Item" : "Add Positive Item";

    return (
        <Dialog header={header} visible={!!toEdit} className="large-dialog" draggable={false} onHide={onHide}>
            <PositiveItemForm positiveItem={toEdit} />
        </Dialog>
    )
}